import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';

import UpdateUser from './UpdateUser';
import ChangePassword from './ChangePassword';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },

}));

const SimpleTabs = props => {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    return (
        <div className={classes.root}>
            <AppBar position="static">
                <Tabs value={value} onChange={(event, newValue) => setValue(newValue)} aria-label="Tabs">
                    <Tab label="Update User" {...a11yProps(0)} />
                    <Tab label="Change Password" {...a11yProps(1)} />
                </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
                <UpdateUser showNotification={props.showNotification} closeModel={props.closeModel} selectedUser={props.selectedUser} />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <ChangePassword showNotification={props.showNotification} closeModel={props.closeModel} selectedUser={props.selectedUser} />
            </TabPanel>
        </div>
    );
}

export default SimpleTabs
